import type { PlatformStatistics } from '@perplexicon/api-client';

import { OVERALL_HEADING_ICON, OVERALL_STAT_ICONS } from '../profile-assets.js';
import { ProfileSectionHeading } from './ProfileSectionHeading.js';
import { ProfileStatTile } from './ProfileStatTile.js';

/**
 * The platform-wide totals (APP_SPEC §13), shown inside the profile hero
 * under an "Overall" heading — there is no separate Statistics card any more.
 * One consistent stat component for every field, laid out on desktop as a
 * single compact row that sits *beside* the identity block in the hero (not
 * a full-width strip beneath it), separated by spacing rather than borders.
 */
const ITEMS: Array<{ key: keyof PlatformStatistics; label: string }> = [
  { key: 'gamesPlayed', label: 'Played' },
  { key: 'gamesWon', label: 'Won' },
  { key: 'gamesLost', label: 'Lost' },
  { key: 'gamesDrawn', label: 'Drawn' },
  { key: 'gamesAbandoned', label: 'Abandoned' },
];

export interface OverallStatsProps {
  statistics: PlatformStatistics;
}

export function OverallStats({ statistics }: OverallStatsProps) {
  return (
    <div className="min-w-0">
      <ProfileSectionHeading
        size="sub"
        title="Overall"
        className="mb-3.5"
        icon={
          <img
            src={OVERALL_HEADING_ICON}
            alt=""
            aria-hidden="true"
            className="h-9 w-9 shrink-0 object-contain tablet:h-10 tablet:w-10"
          />
        }
      />
      {/* Five across only where the plaques genuinely have room for their
          longest label ("Abandoned") — full width at tablet, and the hero's
          third column once it is wide enough. Between the desktop and wide
          breakpoints that column is too narrow, so the totals wrap to 3 + 2
          rather than being squeezed past legibility. */}
      <div className="grid grid-cols-3 gap-2 tablet:grid-cols-5 desktop:grid-cols-3 wide:grid-cols-5">
        {ITEMS.map(({ key, label }) => (
          <ProfileStatTile
            key={key}
            iconSrc={OVERALL_STAT_ICONS[key]}
            label={label}
            value={statistics[key].toLocaleString()}
          />
        ))}
      </div>
    </div>
  );
}
